import { computed, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {MovableChildProvided} from '../movable/models';
import {Movable} from '../movable/Movable';
import {DraggableChildProvided, DraggableComponentProps} from '../models';
import {DragDropContextStore} from '../drag-drop-context/DragDropContextStore';
import {DroppableStore} from '../droppable/DroppableStore';
import {DraggableStore} from './DraggableStore';

@observer
export class DraggableImpl extends React.Component<DraggableComponentProps & { droppableStore: DroppableStore }> {
  readonly store: DraggableStore;

  constructor(props: Readonly<DraggableComponentProps & { droppableStore: DroppableStore }>) {
    super(props);
    makeObservable(this);
    this.store = new DraggableStore(this);
  }

  componentDidMount() {
    this.store.mount();
  }

  @computed
  get dragDropContextStore(): DragDropContextStore {
    return this.props.droppableStore
      .component.props.contextStore;
  }

  prepareDraggableProvided = (movableProvided: MovableChildProvided): DraggableChildProvided => {
    const props = this.props;
    const provided = movableProvided;

    return {
      draggableId: props.draggableId,
      isDisabled: props.isDragDisabled === true,
      isDragging: provided.isDragging,
      isMirror: provided.isMirror,
      movableState: provided.state,
      draggableProps: provided.movableProps,
      mirrorProps: provided.mirrorProps
    };
  };

  render() {
    const props = this.props;
    const store = this.store;
    return (
      <Movable movableId={props.draggableId}
               disabled={props.isDragDisabled === true}
               onDragStart={store.onDragStart}
               onDragMove={store.onDragMove}
               onDragEnd={store.onDragEnd}
               onDragCancel={store.onDragCancel}
               adjustMirrorPosition={props.adjustMirrorPosition}>
        {this.renderMovableChild}
      </Movable>
    );
  }

  renderMovableChild = (movableChildProvided: MovableChildProvided) => {
    const draggableChildProvided = this.prepareDraggableProvided(movableChildProvided);
    const renderFn = this.props.children;
    return renderFn(draggableChildProvided);
  };

  componentWillUnmount() {
    this.store.dispose();
  }
}
